function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Diagrams/Active/Column");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "hover",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(-488.000000, -84.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Diagrams/Active/Column",
  transform: "translate(488.000000, 84.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy-6"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  fillOpacity: 0.1,
  fill: "#FFFFFF",
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.9,10.8 L5.5,10.8 C5.77614237,10.8 6,11.0238576 6,11.3 L6,18 L6,18 L2.4,18 L2.4,11.3 C2.4,11.0238576 2.62385763,10.8 2.9,10.8 Z",
  id: "Rectangle",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.7,4.8 L10.3,4.8 C10.5761424,4.8 10.8,5.02385763 10.8,5.3 L10.8,18 L10.8,18 L7.2,18 L7.2,5.3 C7.2,5.02385763 7.42385763,4.8 7.7,4.8 Z",
  id: "Rectangle-Copy-5",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5,8.4 L15.1,8.4 C15.3761424,8.4 15.6,8.62385763 15.6,8.9 L15.6,18 L15.6,18 L12,18 L12,8.9 C12,8.62385763 12.2238576,8.4 12.5,8.4 Z",
  id: "Rectangle-Copy-6",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
})))));

var SvgColumn = function SvgColumn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColumn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/column.ad09e234.svg";
export { ForwardRef as ReactComponent };